/*
 * QR Code generator library (Kotlin port)
 *
 * Based on the Java implementation by Project Nayuki (MIT License)
 * https://www.nayuki.io/page/qr-code-generator-library
 */

package io.nayuki.qrcodegen

class DataTooLongException : IllegalArgumentException {
    constructor() : super()
    constructor(message: String) : super(message)
}
